import { booleanAttribute, Component, computed, input, Input } from '@angular/core';
import { SecurityType } from '@models/shares/security-type';

@Component({
  selector: 'app-share-class-type-label',
  standalone: true,
  templateUrl: './share-class-type-label.component.html',
  styleUrl: './share-class-type-label.component.scss'
})
export class ShareClassTypeLabelComponent {
  @Input({ transform: booleanAttribute }) hidePrice = false;
  securityType = input.required<SecurityType>();

  readonly currency = 'AUD';

  nominalPrice = computed(() => this.securityType() ? SecurityType.getMoneyLabel(this.securityType().nominalPrice) : '');
  unpaidAmount = computed(() => this.securityType() ? SecurityType.getMoneyLabel(this.securityType().unpaidAmount) : '');
}
